import * as React from 'react';
import styled from 'styled-components';
import { useAppSelector } from '../../appStore';
import { IDisplayLogicEditModel } from '../../models';
import { BranchingLogicRule } from './BranchingLogicRule';
import { NewBranchingLogicRule } from './NewBranchingLogicRule';
import { QuestionBranchingLogicScope } from './QuestionBranchingLogicScope';

type QuestionBranchingLogicContainerProps = {
	questionId?: number;
	scope: QuestionBranchingLogicScope;
};

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 1rem;
`;
Container.displayName = 'Container';

const QuestionBranchingLogic = ({ questionId, scope }: QuestionBranchingLogicContainerProps) => {
	const { branchingLogicEditModels, validationModels } = useAppSelector((state) => state.questionBranchingLogic);

	const { validationResults: dataMissingValidationResults } = useAppSelector((state) => state.surveyBuilder);

	return (
		<Container>
			{branchingLogicEditModels.map((bl: IDisplayLogicEditModel, index: number) => (
				<BranchingLogicRule
					key={index}
					scope={scope}
					branchingLogic={bl}
					branchingLogicIndex={index}
					dataMissingValidationResults={dataMissingValidationResults}
					validationResults={validationModels?.[index]?.validationResults}
				/>
			))}
			<NewBranchingLogicRule questionId={questionId} scope={scope} />
		</Container>
	);
};

export { QuestionBranchingLogic, type QuestionBranchingLogicContainerProps };
